import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
} from 'app/services';
import { actionIcon } from 'app/components/global';

import reportTypes from './reportTypes';

import directive from './archived-reports.directive';
import controller from './archived-reports.controller';


export const archivedReportsRouteConfig = {
  template: require('./archived-reports.html'),
  controller: 'ArchivedReportsController',
  controllerAs: 'archivedReportsVM',
};

export default angular.module('app.components.reports.archivedReports', [
  userService,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
  actionIcon,
  reportTypes,
])
  .directive('archivedReports', directive)
  .controller('ArchivedReportsController', controller)
  .name;

console.log('app.components.reports.archivedReports created');
